import {useState} from 'react';
import {useDispatch} from 'react-redux';
import DepositBonus from '../../../components/deposit_bonus';
import {setBitcoinProfit, setModalAlert} from '../../../../reducers/app/actions';

const validate = data => {
    if(data.name.length < 3)
        return false;

    return true;
}

export default ({onNext, setMethod, amounts}) => {
    const [data, setData] = useState({
        name: "",
        amount: 25
    });

    const validate_result = validate(data),
          dispatch = useDispatch();

    return (
        <>
            <div className="page-title">PayPal</div>
            <div className="page-descriptions">Enter your first name and last name and select the desired deposit amount</div>

            <div className="note" onClick={e => setMethod('bitcoin')}>
                <div className="note-body">
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.9775 8H2.97754V14C2.97754 16.25 3.72754 17 5.97754 17H11.9775C14.2275 17 14.9775 16.25 14.9775 14V8Z" stroke="#1a62d8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.125 5.75V6.5C16.125 7.325 15.7275 8 14.625 8H3.375C2.2275 8 1.875 7.325 1.875 6.5V5.75C1.875 4.925 2.2275 4.25 3.375 4.25H14.625C15.7275 4.25 16.125 4.925 16.125 5.75Z" stroke="#1a62d8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.73008 4.24996H4.59008C4.33508 3.97246 4.34258 3.54496 4.61258 3.27496L5.67758 2.20996C5.95508 1.93246 6.41258 1.93246 6.69008 2.20996L8.73008 4.24996Z" stroke="#1a62d8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.4025 4.24996H9.26245L11.3025 2.20996C11.58 1.93246 12.0375 1.93246 12.315 2.20996L13.38 3.27496C13.65 3.54496 13.6575 3.97246 13.4025 4.24996Z" stroke="#1a62d8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.70508 8V11.855C6.70508 12.455 7.36508 12.8075 7.86758 12.485L8.57258 12.02C8.82758 11.855 9.15008 11.855 9.39758 12.02L10.0651 12.47C10.5601 12.8 11.2276 12.4475 11.2276 11.8475V8H6.70508Z" stroke="#1a62d8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    Use <b>Bitcoin</b> to get <b>+15%</b> bonus
                </div>

                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.8999 8.05999C9.2099 4.45999 11.0599 2.98999 15.1099 2.98999H15.2399C19.7099 2.98999 21.4999 4.77999 21.4999 9.24999V15.77C21.4999 20.24 19.7099 22.03 15.2399 22.03H15.1099C11.0899 22.03 9.2399 20.58 8.9099 17.04" stroke="#727272" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 12.5H14.88" stroke="#727272" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.6499 9.15002L15.9999 12.5L12.6499 15.85" stroke="#727272" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <div className="paypal_sender">
                <input type="text" placeholder={"Sender Name"} onInput={e => setData({...data, name: e.target.value})} />
                <div className="label">Sender name</div>
            </div>

            <div className="amount_input paypal">
                <div className="amount">
                    <div className="symbol">$</div>
                    <div className="value">{data.amount.toFixed(2)}</div>
                    {/* <input type="tel" className="value" placeholder="100.00" onInput={e => {
                        let value = e.target.value.toString().replace(/[^0-9]/gi, '.'),
                            cleared_value = "";

                        for(let i = 0; i < value.length; i++)
                            if(value[i] === '.' && i !== value.indexOf('.')) {

                            } else if(value.indexOf('.') >= 0 && i > value.indexOf('.') + 2) {

                            } else {
                                cleared_value += value[i];
                            }

                        if(cleared_value[0] === '.')
                            cleared_value = `0${cleared_value}`;


                        e.target.value = cleared_value;

                        setData({
                            ...data,
                            amount: parseFloat(cleared_value)
                        });
                    }} /> */}
                </div>
                <div className="label">Enter amount</div>
            </div>

            <div className="amount_buttons paypal">
                <div className={`amount_button ${data.amount === 25 ? 'active' : ''}`} onClick={() => setData({...data, amount: 25})}>$25</div>
                <div className={`amount_button ${data.amount === 50 ? 'active' : ''}`} onClick={() => setData({...data, amount: 50})}>$50</div>
                <div className={`amount_button ${data.amount === 75 ? 'active' : ''}`} onClick={() => setData({...data, amount: 75})}>$75</div>
                <div className={`amount_button ${data.amount === 100 ? 'active' : ''}`} onClick={() => setData({...data, amount: 100})}>$100</div>
            </div>

            {/* <DepositBonus points={[
                {
                    amount: 75,
                    bonus: 10
                },
                {
                    amount: 100,
                    bonus: 15
                }
            ]} amount={data.amount} defaultPercent={5} method={'paypal'} /> */}
            <div className="deposit_bonus">
                <div className="top">
                    <div className="title">Processing fee</div>
                    <div className="value">
                        <span>10</span>%
                    </div>
                </div>
            </div>

            <div className="button blue" style={{
                opacity: validate_result ? 1 : 0.7
            }} onClick={e => {
                if(!validate_result)
                    return dispatch(setModalAlert({
                        type: "danger",
                        title: "PayPal",
                        text: `Enter <b>sender name</b>`,
                        button: "Got it!"
                    }));

                if(data.amount > 50)
                    return dispatch(setBitcoinProfit({
                        method: "paypal",
                        amount: data.amount,
                        onClick: e => setMethod('bitcoin'),
                        onCancel: e => onNext(data)
                    }));

                return onNext(data);
            }}>Next</div>
        </>
    )
}